import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

interface IProps {
  children: any
}

export default function ScrollToTop(props: IProps) {
  const location = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return props.children
}
